// src/components/dashboard/SuperClientDashboard.js
import React from "react";
import { Routes, Route, useParams } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import ClientSettings from "../clientadmin/pages/ClientSettings";
import ClientModulesManager from "../clientadmin/pages/ClientModulesManager";

const SuperClientDashboard = () => {
  // Gestion du thème
  const themeContext = useTheme();
  const theme = themeContext?.theme || "light";
  const params = useParams();

  console.log("🚀 SuperClientDashboard loaded");
  console.log("📍 Current URL:", window.location.pathname);
  console.log("📍 useParams:", params);

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      theme === 'dark' 
        ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900' 
        : 'bg-gray-50'
    }`}>
      
      {/* Contenu principal - pleine largeur pour les clients */}
      <div className={`p-8 transition-colors duration-300 ${
        theme === 'dark' ? 'text-white' : 'text-gray-900'
      }`}>
        
        {/* Routes pour les pages client admin */}
        <Routes>
          {/* Routes spécifiques - Pattern simple */}
          <Route path="preferences" element={<ClientSettings />} />
          <Route path="parametres" element={<ClientSettings />} />
          <Route path="modules" element={<ClientModulesManager />} />
          
          {/* Page par défaut */}
          <Route index element={
            <div className="text-center py-12">
              <h2 className={`text-2xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                Paramètres Client
              </h2>
              <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
                Gestion de vos préférences
              </p>
            </div>
          } />
          
          {/* Route de fallback */}
          <Route path="*" element={
            <div className="text-center py-12">
              <h2 className={`text-2xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                Page non trouvée
              </h2>
              <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
                Cette page n'existe pas dans vos paramètres
              </p>
            </div>
          } />
        </Routes>
      </div>
    </div>
  );
};

export default SuperClientDashboard;